import React, { Suspense, lazy } from 'react';
import { Header } from "@/components/Header";
import { HeroSection } from "@/components/HeroSection";

// ABAIXO DO FOLD - Lazy loaded para performance
const CuratedSection = lazy(() => import("@/components/CuratedSection"));
const DifferenceSection = lazy(() => import("@/components/DifferenceSection"));
const ProcessSection = lazy(() => import("@/components/ProcessSection"));
const TestimonialsSection = lazy(() => import("@/components/TestimonialsSection"));
const ContactSection = lazy(() => import("@/components/ContactSection"));
const Footer = lazy(() => import("@/components/Footer"));

// Loading placeholder minimalista
const SectionLoader = () => (
  <div className="min-h-[200px] bg-muted/20 animate-pulse" aria-hidden="true" />
);

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main role="main">
        <HeroSection />
        <Suspense fallback={<SectionLoader />}>
          <CuratedSection />
        </Suspense>
        <Suspense fallback={<SectionLoader />}>
          <DifferenceSection />
        </Suspense>
        <Suspense fallback={<SectionLoader />}>
          <ProcessSection />
        </Suspense>
        <Suspense fallback={<SectionLoader />}>
          <TestimonialsSection />
        </Suspense>
        <Suspense fallback={<SectionLoader />}>
          <ContactSection />
        </Suspense>
      </main>
      <Suspense fallback={<SectionLoader />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
